import { Question } from 'src/app/_models/question';
import { DataUtilService } from './data-util.service';
import { QuizEnvelop } from '../_models/quizEnvelop';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BehaviorSubject} from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContentService {
 

  public quizEnvelopSubject: BehaviorSubject<QuizEnvelop> = new BehaviorSubject<QuizEnvelop>(new QuizEnvelop());
  public quizEnvelopObservable=this.quizEnvelopSubject.asObservable
  headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
  options = {headers: this.headers}
  constructor(
    private http: HttpClient,
    private dataUtilService:DataUtilService
    ) { }
  
    getConcept(server_concept_id:number){
      return this.http.get<any>(`${environment.apiUrl}/study/apiconceptshow?server_concept_id=${server_concept_id}`).pipe(map(
        value=>{
        
          if(this.dataUtilService.isGoodResponse(value)){
            return this.dataUtilService.myData(value)
          }else{
            return {}
          }
        }
      ))
    }
  getAdminIndex() {
    return this.http.get<any>(`${environment.apiUrl}/study/adminindex`).pipe(map(
      value=>{
        if(this.dataUtilService.isGoodResponse(value)){
          return this.dataUtilService.myData(value)
        }else{
          return {}
        }
      }
    ))
  }
  getConcentSubTopicsIndex(serverSubTopicId:number) {
    return this.http.get<any>(`${environment.apiUrl}/study/apisubtopiconceptindex/${serverSubTopicId}`).pipe(map(
      value=>{
        if(this.dataUtilService.isGoodResponse(value)){
          return this.dataUtilService.myData(value)
        }else{
          return {}
        }
      }
    ))
  }
  createContent(formData:FormData){
    const url = `${environment.apiUrl}/study/apisaveconcept`
   return  this.http.post(url, formData).pipe(map(xx => {
        if(this.dataUtilService.isGoodResponse(xx)){
          let myData=this.dataUtilService.myData(xx)
           return myData    
        }else{
          return {}
        } 
      }))
    }
    searchConcepts(val:string,server_subtopic_id:number){
      return this.http.get<any>(`${environment.apiUrl}/study/searchaddconceptlist/${server_subtopic_id}?q=${val}`).pipe(map(
        data=>{
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }
        }
      ))
    }
    addConceptToSubTopic(server_concept_id:number,server_subtopic_id:number){
      return this.http.get<any>(`${environment.apiUrl}/study/addconcepttotopicsave/${server_subtopic_id}?serverConceptId=${server_concept_id}`).pipe(map(
        data=>{
          if(this.dataUtilService.isGoodResponse(data)){
            return this.dataUtilService.myData(data)
          }
        }
      ))
  
    }
}